/**
 * 渲染公共快捷菜单
 */
import { Vue, Component } from 'vue-property-decorator';
import event from '@acgn/herm/src/util/event';

@Component({})
export default class RenderMenuMixin extends Vue {
  private async created() {
    this.$nextTick(() => {
      event.emit('$renderMenuFn', (h: any) => {
        return (this as any).renderMenu();
      });
    });
  }

  private async beforeDestroy() {
    event.emit('$destroyRenderMenuFn');
  }
}
